import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { deleteBanner } from "../firebase";
import { Table, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import EllipsisText from "react-ellipsis-text";
import { CopyToClipboard } from "react-copy-to-clipboard";

const ListItem = ({ banner }) => {
  const domain = process.env.REACT_APP_PUBLIC_URL;
  const dispatch = useDispatch();
  const [deleteItem, setDeleteItem] = useState(false);
  const [copyUrl, setCopyUrl] = useState(false);
  const user = useSelector((state) => state.user);

  const handleBannerRemove = () => {
    const conf = window.confirm(
      `You are about to delete ${banner.bannerTitle}. Please confirm this action`
    );
    if (conf) {
      setDeleteItem(true);
      deleteBanner(banner.id, dispatch).then((message) => console.log(message));
    }
  };

  const updateSetCopyUrl = () => {
    setCopyUrl(true);
    setTimeout(() => {
      setCopyUrl(false);
    }, 5000);
  };

  const last = banner.lastModAt.toDate().toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "2-digit",
  });

  useEffect(() => {
    //console.log("user", user, "banner", banner);
    //console.log(banner.userId === user.id, banner.userId, user.id);
  }, [user, banner]);

  return (
    <Table.Row className={deleteItem ? "item-delete" : ""}>
      <Table.Cell>{banner.adNumber}</Table.Cell>
      <Table.Cell>{banner.advertiser}</Table.Cell>
      <Table.Cell>
        <Link to={`/${banner.retailer}/banner/${banner.id}`}>
          {banner.bannerTitle}
        </Link>
      </Table.Cell>
      <Table.Cell>
        {banner.adServeData && <Icon name="check" color="green" />}
      </Table.Cell>
      <Table.Cell>{banner.retailer}</Table.Cell>
      <Table.Cell>{banner.bannerType}</Table.Cell>
      <Table.Cell>
        <EllipsisText text={banner.lastModBy} length={13} />{" "}
        <span className="time">{last}</span>
      </Table.Cell>
      <Table.Cell className="center">
        <CopyToClipboard
          text={`${domain}/#/${banner.retailer}/banner/${banner.id}`}
          onCopy={() => updateSetCopyUrl()}
        >
          <Icon
            name={copyUrl ? "clipboard check" : "clipboard outline"}
            size="large"
            color={copyUrl ? "green" : "grey"}
          />
        </CopyToClipboard>
      </Table.Cell>
      <Table.Cell className="center">
        {banner.currentUser && banner.userId !== user.id ? (
          <Icon
            name="edit"
            size="large"
            color="grey"
            title={`In edit by ${banner.currentUser}`}
          />
        ) : (
          <Link
            to={`/${banner.retailer}/banner/${banner.id}/edit`}
            title={
              banner.currentUser
                ? `In edit by ${banner.currentUser}`
                : "Free to edit"
            }
          >
            <Icon
              name="edit"
              color={banner.userId === user.id ? "orange" : "blue"}
              size="large"
            />
          </Link>
        )}
      </Table.Cell>
      <Table.Cell className="center">
        <Icon
          onClick={handleBannerRemove}
          disabled={banner.currentUser ? true : false}
          size="large"
          color="red"
          name="trash"
          className="pointer"
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default ListItem;
